import styled from 'styled-components';

import { colors } from '../../styles/colors';

export const UnavailableLinkMessageStyle = styled.span`
  color: ${colors.Red};
  font-weight: bold;
  font-size: 1em;
  line-height: 22px;
  text-align: center;
`;
